// src/store/reducers/tagReducer.js
import { TAG_ACTIONS } from '../actions/actionTypes';

const initialState = {
  tags: [],
  selectedTag: null,
  loading: false,
  error: null,
  success: null,
  meta: {
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 1,
  },
  filters: {
    page: 1,
    limit: 20,
    search: '',
    type: '',
    isActive: true,
    sortBy: 'name',
    sortOrder: 'asc',
  },
  popularTags: [],
  stats: null,
};

const tagReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch tags
    case TAG_ACTIONS.FETCH_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TAG_ACTIONS.FETCH_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: action.payload.data || [],
        meta: action.payload.meta || initialState.meta,
        error: null,
      };

    case TAG_ACTIONS.FETCH_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        tags: [],
      };

    // Fetch single tag
    case TAG_ACTIONS.FETCH_TAG_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TAG_ACTIONS.FETCH_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedTag: action.payload,
        error: null,
      };

    case TAG_ACTIONS.FETCH_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        selectedTag: null,
      };

    // Create tag
    case TAG_ACTIONS.CREATE_TAG_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case TAG_ACTIONS.CREATE_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: [action.payload, ...state.tags],
        success: 'Tag créé avec succès',
        error: null,
      };

    case TAG_ACTIONS.CREATE_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Update tag
    case TAG_ACTIONS.UPDATE_TAG_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case TAG_ACTIONS.UPDATE_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: state.tags.map(tag =>
          tag.id === action.payload.id ? action.payload : tag
        ),
        selectedTag: action.payload,
        success: 'Tag mis à jour avec succès',
        error: null,
      };

    case TAG_ACTIONS.UPDATE_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Delete tag
    case TAG_ACTIONS.DELETE_TAG_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case TAG_ACTIONS.DELETE_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: state.tags.filter(tag => tag.id !== action.payload.id),
        success: action.payload.message || 'Tag supprimé avec succès',
        error: null,
      };

    case TAG_ACTIONS.DELETE_TAG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Fetch tag stats
    case TAG_ACTIONS.FETCH_TAG_STATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TAG_ACTIONS.FETCH_TAG_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload,
        error: null,
      };

    case TAG_ACTIONS.FETCH_TAG_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        stats: null,
      };

    // Fetch popular tags
    case TAG_ACTIONS.FETCH_POPULAR_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TAG_ACTIONS.FETCH_POPULAR_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        popularTags: action.payload,
        error: null,
      };

    case TAG_ACTIONS.FETCH_POPULAR_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        popularTags: [],
      };

    // Merge tags
    case TAG_ACTIONS.MERGE_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TAG_ACTIONS.MERGE_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: state.tags.filter(tag => tag.id !== action.payload.sourceTagId),
        success: 'Tags fusionnés avec succès',
        error: null,
      };

    case TAG_ACTIONS.MERGE_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Bulk delete
    case TAG_ACTIONS.BULK_DELETE_TAGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TAG_ACTIONS.BULK_DELETE_TAGS_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: state.tags.filter(tag => !action.payload.ids.includes(tag.id)),
        success: action.payload.message || 'Tags supprimés avec succès',
        error: null,
      };

    case TAG_ACTIONS.BULK_DELETE_TAGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Set filters
    case TAG_ACTIONS.SET_TAG_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    // Clear states
    case TAG_ACTIONS.CLEAR_TAG_ERROR:
      return {
        ...state,
        error: null,
      };

    case TAG_ACTIONS.CLEAR_TAG_SUCCESS:
      return {
        ...state,
        success: null,
      };

    case TAG_ACTIONS.CLEAR_SELECTED_TAG:
      return {
        ...state,
        selectedTag: null,
        stats: null,
      };

    default:
      return state;
  }
};

export default tagReducer;